import { ALIGN_CLASSES as e, ALIGN_CLASSES_INVERSE as t, DEFAULT_ALIGNMENT as n } from "../../constants.js";
import { defineAttrs as r } from "../../utils/typed-attrs.js";
//#region src/specs/decorators/centerable.ts
var i = r({ alignment: { default: n } });
function a(n) {
	n.attrs = Object.assign({}, n.attrs, i), n.parseDOM?.forEach(function(e) {
		let n = e.getAttrs;
		e.getAttrs = (e) => {
			let r, i = {};
			return n && Object.assign(i, n(e)), e.classList.forEach((e) => {
				e in t && (r = t[e]);
			}), r && Object.assign(i, { alignment: r }), i;
		};
	});
	let r = n.toDOM;
	return n.toDOM = (t) => {
		let n = t.attrs;
		if (!r) throw Error("must specify a toDOM method");
		let i = r(t);
		if (!Array.isArray(i) || i.length < 2) throw Error("must specify at least two elements in output spec");
		i[1] === 0 && i.splice(1, 0, {});
		let a = i[1];
		return a?.class && typeof a.class == "string" ? a.class += ` ${e[n.alignment]}` : a.class = e[n.alignment], i;
	}, n;
}
//#endregion
export { a as centerable, i as centerableAttrs };
